import { clearAnonSession, getAnonSession, getUserFromToken, logout } from './auth'
import { anonApi, authApi, teamApi } from './api'
import {
  createBootstrapAuthenticatedUser,
  WorkspaceBootstrapError,
} from './authBootstrapCore'

export { WorkspaceBootstrapError }

export const bootstrapAuthenticatedUser = createBootstrapAuthenticatedUser({
  authApi,
  teamApi,
  anonApi,
  getAnonSession,
  clearAnonSession,
  getUserFromToken,
  storage: window.localStorage,
})

export function logoutAfterBootstrapFailure() {
  logout()
}
